import { useState, useEffect } from 'react';

import { Grid, Typography, Button, CircularProgress } from '@mui/material';
import ProductrawDashboard from 'components/productraw/ProductrawDashboard';
import { setProductrawDashboardProductrawList, updateProductObj } from 'store/slice/PharmaSlice';
import { useSelector, useDispatch } from 'react-redux';
import CtitemDashboard from 'components/ctitem/CtitemDashboard';
import { setCtitemDashboardCtitemList } from 'store/slice/PharmaSlice';
import { getCtitemInfoByCitedAPI } from 'components/ctitem/CtitemAPI';
import MyDate from 'core/components/MyDate';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MyDate1 from 'core/components/MyDate1';
import dayjs from 'dayjs';

import { setApiInProgress } from 'store/slice/HeaderSlice';
import { updateRMstatusAPI } from 'api/OmsOrdermgmtWebServices';
import { setSelectedTaskObj } from 'store/slice/AppSlice';
import { setCompleteTaskButtonEnabled } from 'store/slice/AppSlice';
import { use } from 'react';

export default function RmmanagementActionImpl() {
    const dispatch = useDispatch();
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const { ctitemList } = useSelector((state) => state.pharmaslice);
    const [rmOrderDate, setRmOrderDate] = useState(null);
    const [rmReceivedDate, setRmReceivedDate] = useState(null);
    const { apiInProgress } = useSelector((state) => state.headerslice);
    const [saveEnabled, setSaveEnabled] = useState(false);
    const { selectedTaskObj } = useSelector((state) => state.appslice.wkflow);

    useEffect(() => {
        console.log("selectedTaskObj=>" + JSON.stringify(selectedTaskObj));
        //handleSaveButtonVisibility();   
        if (productObj.rmorderedon !== null && selectedTaskObj.taskid === 5) dispatch(setCompleteTaskButtonEnabled(true));
        else if (productObj.rmreceivedon !== null && selectedTaskObj.taskid === 6) dispatch(setCompleteTaskButtonEnabled(true));
        else dispatch(setCompleteTaskButtonEnabled(false));

    }, [productObj])

    useEffect(() => {
        if (dateChanged(productObj.rmorderedon, rmOrderDate) || dateChanged(productObj.rmreceivedon, rmReceivedDate)) setSaveEnabled(true);
        else setSaveEnabled(false);

    }, [rmOrderDate, rmReceivedDate])
    const [checked, setChecked] = useState(false);

    const handleSaveButtonVisibility = () => {

        setRmOrderDate(productObj.rmorderedon)
        setRmReceivedDate(productObj.rmreceivedon)

        if (dateChanged(productObj.rmorderedon, rmOrderDate) || dateChanged(productObj.rmreceivedon, rmReceivedDate)) setSaveEnabled(true);
        else setSaveEnabled(false);

    }
    const handleChange = (event) => {
        setChecked(event.target.checked); // Update the state with the checkbox value
    };

    useEffect(() => {
        handleSaveButtonVisibility();

        dispatch(setCtitemDashboardCtitemList(
            ctitemList.filter(ctitemObj => ctitemObj.ctid === productObj.ctid)
        ))
    }, []);

    const updateRMstatusSuccessCallback = (responseObj) => {
        dispatch(setApiInProgress(false));

        dispatch(updateProductObj(responseObj.productInfo));
    }
    const updateRMstatusFailureCallback = (msg) => {
        dispatch(setApiInProgress(false));
        alert(msg);
    }
    const dateChanged = (date1, date2) => {
        if (date1 === null && date2 === null) return false;

        const dayjsDate1 = dayjs(date1);
        const dayjsDate2 = dayjs(date2);
        return !dayjsDate1.isSame(dayjsDate2)
    }
    const updateRMDate = () => {
        dispatch(setApiInProgress(true));
        let payload = {
            productId: productObj.id,
        }

        if (dateChanged(productObj.rmorderedon, rmOrderDate)) {
            payload = {
                ...payload,
                rmOrderedOn: rmOrderDate,
            }
        }
        if (dateChanged(productObj.rmreceivedon, rmReceivedDate)) {
            payload = {
                ...payload,
                rmReceivedOn: rmReceivedDate,
            }
        }
        updateRMstatusAPI(payload, updateRMstatusSuccessCallback, updateRMstatusFailureCallback)
    }

    const updateRMstatus = () => {
        dispatch(setApiInProgress(true));
        if (checked) {
            let payload = {
                productId: productObj.id,
                rmOrderedOn: rmOrderDate,
                rmReceivedOn: rmReceivedDate,
                rmStatus: "RM READY"
            }
            updateRMstatusAPI(payload, updateRMstatusSuccessCallback, updateRMstatusFailureCallback)
        }

    }
    return (
        <>

            <Grid container direction="row" sx={{ width: '100%', justifyContent: "space-between", alignItems: 'flex-start' }}>
                {/* <Grid lg={9} item>
            <CtitemDashboard />
        </Grid> */}
                <Grid lg={12} item sx={{ paddingTop: 2 }}>

                    <Grid container direction="column" sx={{ width: '100%', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                        <Grid item sx={{ width: '100%', backgroundColor: 'white', padding: 1, borderRadius: 5 }}>
                            <Grid item>
                                <Typography sx={{ padding: .5 }} color="primary">RM Ordered On</Typography>
                                {selectedTaskObj.taskid === 5 ?
                                    <MyDate1
                                        label=""
                                        defaultValue={productObj.rmorderedon === null ? '' : productObj.rmorderedon}
                                        fieldName="rmOrderDate"
                                        errStr="Wrong date"
                                        setDate={setRmOrderDate}
                                    // disabled={()=>selectedTaskObj.taskid === 5?'false':'true'}
                                    /> :
                                    <>
                                        <Typography sx={{ padding: .5 }} >{productObj.rmorderedon.split('T')[0]}</Typography>
                                    </>}
                            </Grid>
                            <Grid>&nbsp;</Grid>
                            {/* {selectedTaskObj?.taskid === 6 && (
                                <Grid item>
                                    <Typography sx={{ padding: .5 }} color="primary">RM Received On</Typography>
                                    <MyDate1
                                        label=""
                                        defaultValue={productObj.rmreceivedon === null ? '' : productObj.rmreceivedon}
                                        fieldName="rmReceivedDate"
                                        errStr="Wrong date"
                                        setDate={setRmReceivedDate}
                                    />
                                </Grid>
                            )}
                            <Grid>&nbsp;</Grid>
                            <Grid sx={{ textAlign: 'right', justifyContent: 'right' }}>

                                <Button
                                    disabled={
                                        selectedTaskObj?.taskid === 6
                                            ? !rmReceivedDate
                                            : rmOrderDate === null
                                    }
                                    onClick={() => updateRMDate()}
                                >
                                    Save
                                </Button>

                            </Grid> */}
                        </Grid>
                        <Grid>&nbsp;</Grid>
                        {selectedTaskObj?.taskid === 6 && (
                            <Grid container direction="column" sx={{ width: '100%', backgroundColor: 'white', padding: 1, borderRadius: 5 }}>
                                <Grid item sx={{ pb: 1 }}>
                                    <Typography sx={{ padding: .5 }} color="primary">RM Received On</Typography>
                                    <MyDate1
                                        label=""
                                        defaultValue={productObj.rmreceivedon === null ? '' : productObj.rmreceivedon}
                                        fieldName="rmReceivedDate"
                                        errStr="Wrong date"
                                        setDate={setRmReceivedDate}
                                    />
                                </Grid>
                                <Grid item sx={{}}>
                                    <Typography sx={{ padding: .5 }} color="primary"  >Is Raw Material demand Ready for this Product1?</Typography>
                                    <Grid container sx={{ justifyContent: 'space-between' }}>
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={checked}
                                                        onChange={handleChange}
                                                        color="primary"
                                                        label="Yes"
                                                        disabled={productObj.rmstatus === 'RM READY' || rmReceivedDate === null}
                                                    />
                                                }
                                                label="Yes, It is ready"
                                            />
                                        </Grid>
                                        <Grid item>
                                            {apiInProgress && checked ? <CircularProgress /> :
                                                <Button disabled={!checked} onClick={() => updateRMstatus()}>Save</Button>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                </Grid>


            </Grid>
        </>
    )
}